// third-party
import { createSlice } from '@reduxjs/toolkit';
// date imports
import { format, isValid, parse } from 'date-fns';

// project imports
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { AUTO_QUOTE, DAY_WISE_ITINERARY_CONSTANT, DEFAULT_ERROR_MESSAGE, DESTINATION_CONSTANT } from '../constant';
import axios from 'utils/axios';
import { openSnackbar } from './snackbar';
import { extractErrorMessage } from 'views/pages/create-quote/utilities';

const initialState = {
    dayWiseItineraryData: {},
    isGenerateItineraryLoading: false,
    isGenerateItinerarySaving: false,
    currentTabValue: null,
    isDayWiseItineraryEdited: false,
    isDynamicFormModified: {}
};
const slice = createSlice({
    name: 'quotesPageGenerateItinerary',
    initialState,
    reducers: {
        setIsGenerateItineraryLoading: (state, action) => ({
            ...state,
            isGenerateItineraryLoading: action.payload
        }),
        setIsRearrangedSightSeeingLoading: (state) => ({
            ...state,
            isGenerateItinerarySaving: true
        }),
        setCurrentTabValue: (state, action) => ({
            ...state,
            currentTabValue: action.payload
        }),
        saveDayWiseItineraryDataAtTabValue: (state, action) => {
            const { data = {}, sightseeingData: unassignedSightSeeing } = action.payload;
            const previousDayWiseItineraryData = state.dayWiseItineraryData;
            const currentTab = state.currentTabValue;
            return {
                ...state,
                dayWiseItineraryData: {
                    ...previousDayWiseItineraryData,
                    [currentTab]: {
                        itineraryData: data,
                        unassignedSightSeeing
                    }
                }
            };
        },
        setIsDayWiseItineraryEditedAtCurrentTab: (state, action) => ({
            ...state,
            isDayWiseItineraryEdited: action.payload
        }),
        resetDayWiseItineraryStore() {
            return {
                ...initialState
            };
        },
        saveDynamicFormModificationFlag: (state, action) => {
            const { formModifiedKey = 'area' } = action.payload;

            return {
                ...state,
                isDynamicFormModified: {
                    ...state.isDynamicFormModified,
                    [formModifiedKey]: true
                }
            };
        },
        resetDynamicFormModificationFlag: (state) => {
            const isDynamicFormModified = JSON.parse(JSON.stringify(state.isDynamicFormModified));
            Object.keys(isDynamicFormModified).forEach((parentKey) => {
                isDynamicFormModified[parentKey] = false;
            });
            return {
                ...state,
                isDynamicFormModified
            };
        }
    }
});

export default slice.reducer;

export const {
    setIsGenerateItineraryLoading,
    setIsRearrangedSightSeeingLoading,
    saveDayWiseItineraryDataAtTabValue,
    setCurrentTabValue,
    resetDayWiseItineraryStore,
    setIsDayWiseItineraryEditedAtCurrentTab,
    resetDynamicFormModificationFlag,
    saveDynamicFormModificationFlag
} = slice.actions;

// Async Thunks Start

export const GenerateItinerary = (destinationCode, payload) => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}${AUTO_QUOTE}/${DESTINATION_CONSTANT}/${destinationCode}/${DAY_WISE_ITINERARY_CONSTANT}`;
    return (dispatch) => {
        dispatch(setIsGenerateItineraryLoading(true));
        axios
            .post(url, payload)
            .then((response) => {
                const { data, sightseeingData } = response?.data?.data?.results || {};
                dispatch(saveDayWiseItineraryDataAtTabValue({ data, sightseeingData }));
            })
            .catch((error) => {
                const errorResponse = error.response || {}; // Access the error response
                const errorData = errorResponse.data || {}; // Access the data in the error response
                const message = extractErrorMessage(errorData);
                dispatch(
                    openSnackbar({
                        open: true,
                        message: message || DEFAULT_ERROR_MESSAGE,
                        variant: 'alert',
                        alert: { color: 'error' },
                        close: false
                    })
                );
            })
            .finally(() => {
                dispatch(setIsGenerateItineraryLoading(false));
                dispatch(setIsDayWiseItineraryEditedAtCurrentTab(false));
                dispatch(resetDynamicFormModificationFlag());
            });
    };
};
